<template>
  <div style="overflow: hidden">
    <div class="header">
      <div class="bg" />
    </div>
    <div class="headerImg">
      <el-carousel height="164px" :autoplay="true">
        <el-carousel-item v-for="item in 4" :key="item">
          <img src="@/assets/home/homeHeader.jpg" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="carousel">
      <el-carousel height="25px" direction="vertical" :autoplay="true">
        <!-- <el-carousel-item v-for="item in content" :key="item">
          <h3 class="mini">
            <i class="el-icon-message-solid" />
            {{ item }}
          </h3>
        </el-carousel-item> -->
      </el-carousel>
    </div>
    <div class="box">
      <div class="infoNav">
        <div v-for="(item, index) in censusOptions" :key="index">
          <div @click="goRecruit(item.name)">
            <router-link :to="{ path: item.path }">
              <el-card shadow="always">
                <p>
                  <i :class="item.icon" />
                </p>
                <p>
                  <span>
                    {{ item.name }}
                  </span>
                </p>
                <p>
                  <span>{{ item.count }}</span>
                </p>
              </el-card>
            </router-link>
          </div>
        </div>
      </div>
      <div class="content">
        <el-card shadow="always">
          <p>
            <el-tag color="#1564c3" effect="dark"> 人员考勤 </el-tag>
          </p>
          <div>
            <van-cell is-link @click="showPopupDate"> 选择查看考勤月份 </van-cell>
            <p>
              <el-tag type="info"> 当前月份：{{ currentMonth }}月 </el-tag>
            </p>
            <div class="days">
              <span v-for="item in days" :key="item">{{ item }}</span>
            </div>
            <van-popup
              v-model="showPopup"
              position="bottom"
              :style="{ height: '45%' }"
              round
            >
              <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择查看考勤月份"
                :min-date="minDate"
                :max-date="maxDate"
                :formatter="formatter"
                @confirm="confirmMonthBtn"
                @cancel="showPopup = false"
              />
            </van-popup>
          </div>
          <!-- <div v-if="showEcharts == 0"> -->
          <!-- </div> -->

          <div v-show="showEcharts == 0" id="myCharts" ref="myCharts" class="chartsBox" />
          <div v-show="showEcharts == 1" class="chartsText">
            <span> 无数据 </span>
          </div>
        </el-card>

        <el-card shadow="always" class="map">
          <p>
            <el-tag color="#1564c3" effect="dark"> 项目信息 </el-tag>
          </p>
          <el-amap
            vid="amapDemo"
            :plugin="plugin"
            :zoom="zoom"
            :center="center"
            :marker="center"
            class="amap-box"
          >
            <el-amap-marker :position="center"></el-amap-marker>
          </el-amap>
          <div class="itemInfo">
            <p>项目名称：{{ itemInfo.name }}</p>
            <p>项目规模：{{ itemInfo.totalArea }}（㎡）</p>
            <p>项目地址：{{ itemInfo.address }}</p>
            <!-- <p>施工许可证：{{ itemInfo.data4 }}</p> -->
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { getProjectList, postProjectId } from "@/api/app/project";
import { postDetail } from "@/api/app/builderLicenses";
import { encryVuex, decryptVuex } from "@/utils/security";
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
import { getHomePageData, getRecentAttendance } from "@/api/home/dataSummary";
var myCharts;
export default {
  data() {
    return {
      // 地图
      // 层级
      zoom: 13,
      center: [116.397128, 39.916527],
      plugin: [{ convert: true }],
      // 项目信息
      itemInfo: {},
      content: [
        " ECharts，一个纯 Javascript 的图表库",
        "获取 ECharts 的路径有以下几种，请根据您的情况进行选择：",
        "最直接的方法是在 ECharts 的官方网站中挑选适合您的版本进行下载，不同的打包下载应用于不同的开发者功能与体积的需求，或者您也可以直接下载完整版本；开发环境建议下载源代码版本，包含了常见的错误提示和警告。",
      ],
      // 日期选择
      date: "",
      // 当前月份
      currentMonth: "",
      // 年月选择弹窗
      showPopup: false,
      censusOptions: [
        {
          name: "在册人数",
          icon: "icon iconfont icon-untitled18",
          count: "",
          // path: "/recruit",
        },
        {
          name: "今日考勤",
          icon: "icon iconfont icon-jinrizhibanjinglishu",
          count: "",
          // path: "/attendanceHistory",
        },
        {
          name: "正在施工",
          icon: "icon iconfont icon-dingwei",
          count: "",
        },
        {
          name: "在线设备",
          icon: "icon iconfont icon-lianhe5",
          count: "",
          path: "/equipment",
        },
        {
          name: "班组数量",
          icon: "icon iconfont icon-renyuan1",
          count: "",
          path: "/teamInfo",
        },

        {
          name: "认证人次",
          icon: "icon iconfont icon-renzheng",
          count: "",
          path: "/certificationRecord",
        },
      ],
      days: ["一", "二", "三", "四", "五", "六", "日"],
      // 考勤月份选择
      minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
      maxDate: new Date(),
      currentDate: new Date(),
      // dateList: [],
      showEcharts: 0,
      projectId: "",
    };
  },
  computed: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex() {
      return this.$store.state.app.projectId;
    },
  },
  watch: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex(e) {
      if (e !== this.projectId) {
        this.data();
        // this.calendar();
        this.calendar();
        // this.projectInfo();
      }
    },
  },
  created() {
    this.data();
    this.project();
    this.calendar();
    this.projectInfo();
  },
  mounted() {
    this.projectInfo();
  },
  methods: {
    // 通过项目列表获取首次加载项目ID
    project() {},
    // 模块数据统计
    data() {
      let projectId = "";
      getProjectList().then((res) => {
        if (
          !this.$store.state.app.projectId ||
          typeof this.$store.state.app.projectId == "function"
        ) {
          projectId = res.data[0].id;
          this.$store.commit("ProjectId", projectId);
        } else {
          projectId = this.$store.state.app.projectId;
        }
        // this.$store.commit("ProjectId", res.data[0].id);
        getHomePageData(JSON.stringify(projectId)).then((res) => {
          this.censusOptions[0].count = res.data.registeredCount;
          this.censusOptions[1].count = res.data.todayCount;
          this.censusOptions[2].count = res.data.underConstruction;
          this.censusOptions[3].count = res.data.onlineDevices;
          this.censusOptions[4].count = res.data.teamCount;
          this.censusOptions[5].count = res.data.authenticationCount;
        });
        // 项目详细信息
        postProjectId(projectId).then((res) => {
          this.itemInfo = res.data;
          // let centerVuex = res.data.lng, res.data.lat;
          // this.$store.commit("ItemId", centerVuex);
          this.center = [res.data.lng, res.data.lat];
          // this.center = [res.data.lng, res.data.lat];
          // 施工许可证
          postDetail(res.data.id).then((res) => {});
        });
      });
    },
    // 跳转人员名单携带参数
    goRecruit(a) {
      if (a == "在册人数") {
        let query = {};
        this.$router.push({
          path: "/recruit",
          query: {
            status: 1,
          },
        });
      }
      if (a == "今日考勤") {
        let query = {};
        this.$router.push({
          path: "/attendanceHistory",
          query: {
            today: 1,
          },
        });
      }
    },
    // 考勤日期弹出事件
    showPopupDate() {
      this.showPopup = true;
    },
    // 年月弹窗确定按钮
    confirmMonthBtn(value) {
      if (myCharts != null && myCharts != "" && myCharts != undefined) {
        //解决echarts dom已经加载的报错
        let echarts = this.$echarts;
        document.getElementById("myCharts").removeAttribute("_echarts_instance_");
        let yearMonth = [];
        let dateList = [];
        let month = new Date().getMonth() + 1;
        let time = this.datePick.datePick(value).substring(0, 7);
        yearMonth = time.replace("-", "");
        getRecentAttendance(this.$store.state.app.projectId, yearMonth).then((list) => {
          if (this.showEcharts == list.data.length) {
            this.showEcharts = 1;
          }
          if (list.data.length !== 0) {
            this.showEcharts = 0;
          }

          list.data.map((item) => {
            let num = Object.values(item)[0];
            let year = new Date().getFullYear() + "-" + Object.values(item)[1];
            dateList.push([year, num]);
          });
          // let dateList = this.dateList;
          myCharts = echarts.init(this.$refs.myCharts);
          let heatmapData = [];
          let lunarData = [];
          let dateListToday = [];
          let listTodaySlice = [];
          let today = new Date().getDate();
          // 获取本月
          this.currentMonth = this.datePick.datePick(value).substring(6, 7);
          for (var i = 0; i < dateList.length; i++) {
            heatmapData.push([dateList[i][0], Math.random() * 100, dateList[i][1]]);
            lunarData.push([dateList[i][0], 1, dateList[i][1], dateList[i][2]]);
            dateListToday.push([dateList[i][0]]);
          }
          // 获取时间范围
          let dateRange = heatmapData[0][0].slice(0, 7);
          let listToday = dateListToday.reduce((a, b) => {
            return a.concat(b);
          });
          for (var i = 0; i < listToday.length; i++) {
            listTodaySlice.push(listToday[i].slice(-2));
          }
          let showToday = this.datePick.datePick(value).substring(6, 7);
          if (month == showToday) {
            for (var i = 0; i < listTodaySlice.length; i++) {
              if (today == listTodaySlice[i]) {
                lunarData.push([dateList[i][0], 1, dateList[i][1], "今天"]);
              }
            }
          }

          let option = {
            // 提示框组件
            tooltip: {
              formatter: function (params) {
                return "考勤人数 " + params.value[2] + "人";
              },
            },
            visualMap: {
              show: false,
              min: 0,
              max: 300,
              calculable: true,
              seriesIndex: [2],
              orient: "horizontal",
              left: "center",
              bottom: 20,
              inRange: {
                color: ["#e0ffff", "#006edd"],
                opacity: 0.3,
              },
              controller: {
                inRange: {
                  opacity: 0.5,
                },
              },
            },

            calendar: [
              {
                left: "center",
                top: "middle",
                // 每个单元格自适应
                cellSize: ["auto", "auto"],
                yearLabel: { show: true },
                orient: "vertical",
                dayLabel: {
                  firstDay: 1,
                  nameMap: "en",
                },
                monthLabel: {
                  show: false,
                },
                // 时间范围
                range: dateRange,
              },
            ],

            series: [
              {
                type: "scatter",
                coordinateSystem: "calendar",
                symbolSize: 1,
                label: {
                  show: true,
                  formatter: function (params) {
                    let d = echarts.number.parseDate(params.value[0]);
                    var peopleNum = params.value[2];
                    return d.getDate() + "\n\n" + params.value[2] + "人" + "\n\n";
                  },
                  color: "#000",
                },
                data: lunarData,
              },

              {
                type: "scatter",
                coordinateSystem: "calendar",
                symbolSize: 1,
                label: {
                  show: true,
                  formatter: function (params) {
                    return "\n\n\n" + (params.value[3] || "");
                  },
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#a00",
                },
                data: lunarData,
              },
              {
                name: "考勤人数",
                type: "heatmap",
                coordinateSystem: "calendar",
                data: heatmapData,
              },
            ],
          };
          // 项目信息
          // 绘制
          myCharts.setOption(option);
          myCharts.resize();
        });
        this.showPopup = false;
      }
    },
    //年月弹窗取消按钮
    cancelBtn() {
      this.showPopup = false;
    },
    // 考勤日期
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    // 日历坐标
    calendar() {
      if (myCharts != null && myCharts != "" && myCharts != undefined) {
      }
      let yearMonth = [];
      let dateList = [];
      let month = new Date().getMonth() + 1;
      if (new Date().getMonth() < 10) {
        yearMonth = new Date().getFullYear() + "0" + month;
      } else {
        yearMonth = new Date().getFullYear() + month;
      }
      getRecentAttendance(this.$store.state.app.projectId, yearMonth).then((list) => {
        list.data.map((item) => {
          let num = Object.values(item)[0];
          let year = new Date().getFullYear() + "-" + Object.values(item)[1];
          dateList.push([year, num]);
        });
        // let dateList = this.dateList;
        let echarts = this.$echarts;
        // if (myCharts != null && myCharts != "" && myCharts != undefined) {
        //   myCharts.dispose(); //解决echarts dom已经加载的报错
        // }
        myCharts = echarts.init(this.$refs.myCharts);
        let heatmapData = [];
        let lunarData = [];
        let dateListToday = [];
        let listTodaySlice = [];
        let today = new Date().getDate();
        // 获取本月
        this.currentMonth = month;
        // 获取今天
        for (var i = 0; i < dateList.length; i++) {
          heatmapData.push([dateList[i][0], Math.random() * 100, dateList[i][1]]);
          lunarData.push([dateList[i][0], 1, dateList[i][1], dateList[i][2]]);
          dateListToday.push([dateList[i][0]]);
        }
        // 获取时间范围
        let dateRange = heatmapData[0][0].slice(0, 7);
        let listToday = dateListToday.reduce((a, b) => {
          return a.concat(b);
        });
        for (var i = 0; i < listToday.length; i++) {
          listTodaySlice.push(listToday[i].slice(-2));
        }
        for (var i = 0; i < listTodaySlice.length; i++) {
          if (today == listTodaySlice[i]) {
            lunarData.push([dateList[i][0], 1, dateList[i][1], "今天"]);
          }
        }
        let option = {
          // 提示框组件
          tooltip: {
            formatter: function (params) {
              return "考勤人数 " + params.value[2] + "人";
            },
          },
          visualMap: {
            show: false,
            min: 0,
            max: 300,
            calculable: true,
            seriesIndex: [2],
            orient: "horizontal",
            left: "center",
            bottom: 20,
            inRange: {
              color: ["#e0ffff", "#006edd"],
              opacity: 0.3,
            },
            controller: {
              inRange: {
                opacity: 0.5,
              },
            },
          },

          calendar: [
            {
              left: "center",
              top: "middle",
              // 每个单元格自适应
              cellSize: ["auto", "auto"],
              yearLabel: { show: true },
              orient: "vertical",
              dayLabel: {
                firstDay: 1,
                nameMap: "en",
              },
              monthLabel: {
                show: false,
              },
              // 时间范围
              range: dateRange,
            },
          ],

          series: [
            {
              type: "scatter",
              coordinateSystem: "calendar",
              symbolSize: 1,
              label: {
                show: true,
                formatter: function (params) {
                  let d = echarts.number.parseDate(params.value[0]);
                  var peopleNum = params.value[2];
                  return d.getDate() + "\n\n" + params.value[2] + "人" + "\n\n";
                },
                color: "#000",
              },
              data: lunarData,
            },

            {
              type: "scatter",
              coordinateSystem: "calendar",
              symbolSize: 1,
              label: {
                show: true,
                formatter: function (params) {
                  return "\n\n\n" + (params.value[3] || "");
                },
                fontSize: 12,
                fontWeight: 700,
                color: "#a00",
              },
              data: lunarData,
            },
            {
              name: "考勤人数",
              type: "heatmap",
              coordinateSystem: "calendar",
              data: heatmapData,
            },
          ],
        };
        // 项目信息
        // 绘制
        myCharts.setOption(option);
        myCharts.resize();
      });
    },
    projectInfo() {},
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-carousel__button {
  display: none;
}
/deep/ span {
  font-size: 16px;
}
.headerText {
  button {
    width: 100%;
    border: none;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    color: #f0f0f0;
    background-color: #1564c3;
  }
}
.header {
  z-index: -1;
  position: relative;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  background-color: #1564c3;
  .bg {
    width: 500px;
    z-index: -1;
    height: 500px;
    position: fixed;
    border-radius: 50%;
    background-color: #1564c3;
    top: -370px;
    right: -60px;
  }
}
.headerImg {
  // margin-top: 20px;
  padding: 10px 10px 0 10px;
  img {
    width: 100%;
    display: block;
    z-index: 9;
    border-radius: 3px;
  }
}
.carousel {
  padding: 0 10px 0 10px;
  // border-bottom: 1px solid #f0f0f0;
  .mini {
    font-size: 16px;
    i {
      color: #1564c3;
    }
  }
}
.box {
  width: 100%;
  height: 100%;
  padding: 1px 0 5px 0;
  margin-bottom: 50px;
  background-color: #f0f0f0;
  .infoNav {
    // width: 100%;
    height: 100%;
    margin: 10px;
    display: flex;
    flex-wrap: wrap;
    border-radius: 6px;
    background-color: #f0f0f0;
    justify-content: space-between;
    /deep/ span {
      font-size: 16px;
    }
    div {
      width: 110px;
      height: 90px;
      font-size: 14px;
      .el-card {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .el-card__body {
          padding: 0;
        }
        p {
          text-align: center;
        }
        p:nth-child(1) {
          i {
            white-space: nowrap;
            font-size: 25px;
            color: #1564c3;
          }
        }
        p:nth-child(3) {
          span {
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
    }
    div:nth-child(1) {
      margin-bottom: 10px;
    }
    div:nth-child(1) {
      margin-bottom: 10px;
    }
    div:nth-child(1) {
      margin-bottom: 10px;
    }
  }
  .content {
    margin: 10px;
    .el-card {
      width: 100%;
      height: 100%;
      margin-bottom: 10px;
      p {
        font-size: 14px;
      }
      .chartsBox {
        width: 100%;
        height: 400px;
      }
      .chartsText {
        width: 100%;
        display: flex;
        height: 400px;
        align-items: center;
        justify-content: center;
        span {
          font-size: 24px;
        }
      }
      .days {
        display: flex;
        font-weight: bold;
        margin: 5px 0 5px 0;
        justify-content: space-around;
      }
      .van-cell {
        padding-left: 0;
        padding-top: 5px;
      }
      .van-cell__value {
        font-size: 15px;
      }
    }
    .map {
      .amap-box {
        height: 250px;
        max-width: 100%;
        margin: 10px 0 15px 0;
        pointer-events: none;
      }
      .itemInfo {
        p {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
